import { useEffect, type ReactNode } from "react"
import { usePathname, useRouter } from '@/platform/navigation'
import { getSettingsSectionId, SETTINGS_HUB_PATH } from "@/lib/settings-nav"
import { useAuth } from "@/lib/auth-context"
import { cn } from "@/lib/utils"

export default function SettingsLayout({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  const router = useRouter()
  const { user, loading, hasModule } = useAuth()
  const section = getSettingsSectionId(pathname)
  const isSection = section != null
  const touchPosBlocked = section === "touch-pos" &&
    (!hasModule("sales") || user?.features?.touchPos !== true)

  useEffect(() => {
    if (!loading && user && touchPosBlocked) router.replace(SETTINGS_HUB_PATH)
  }, [loading, user, touchPosBlocked, router])

  if (section === "touch-pos" && (loading || !user || touchPosBlocked)) return null

  return <div className={cn("min-w-0", isSection && "settings-panel")}>{children}</div>
}
